import React from 'react';

export const GoogleIcon: React.FC<{ id?: string }> = ({ id = 'google_auth' }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath={`url(#clip0_${id})`}>
      <path d="M19.805 10.2303C19.805 9.55056 19.7499 8.86711 19.6323 8.19836H10.2V12.0492H15.6014C15.3773 13.2911 14.6571 14.3898 13.6025 15.088V17.5866H16.825C18.7173 15.8449 19.805 13.2728 19.805 10.2303Z" fill="#4285F4"/>
      <path d="M10.2 20.0008C12.897 20.0008 15.1731 19.1152 16.8287 17.5866L13.6062 15.0879C12.7096 15.698 11.5522 16.0434 10.2037 16.0434C7.5948 16.0434 5.38274 14.2833 4.58902 11.9169H1.26367V14.4927C2.96127 17.8695 6.41892 20.0008 10.2 20.0008Z" fill="#34A853"/>
      <path d="M4.58565 11.9169C4.16676 10.675 4.16676 9.33008 4.58565 8.08814V5.51236H1.26395C-0.154384 8.33817 -0.154384 11.667 1.26395 14.4927L4.58565 11.9169Z" fill="#FBBC04"/>
      <path d="M10.2 3.95805C11.6257 3.936 13.0036 4.47247 14.0361 5.45722L16.8911 2.60218C15.0833 0.904587 12.6839 -0.0287217 10.2 0.000673888C6.41892 0.000673888 2.96127 2.13185 1.26367 5.51234L4.58537 8.08813C5.37544 5.71811 7.59116 3.95805 10.2 3.95805Z" fill="#EA4335"/>
    </g>
    <defs>
      <clipPath id={`clip0_${id}`}>
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

/**
 * LinkedIn's [in] mark, LinkedIn blue (#0A66C2) with the white letters, 20 px like the Google mark.
 * Per LinkedIn's brand rules the mark is used as-is: no recolouring, no other shape.
 */
export const LinkedInIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="20" height="20" viewBox="0 0 24 24" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="3" fill="#0A66C2" />
    <path
      fill="#FFFFFF"
      d="M7.6 9.5H5.1V18h2.5V9.5zM6.35 5.5a1.45 1.45 0 1 0 0 2.9 1.45 1.45 0 0 0 0-2.9zM18.9 13.3c0-2.6-1.4-3.95-3.3-3.95-1.5 0-2.2.85-2.6 1.45V9.5H10.5V18H13v-4.7c0-1.25.45-2.1 1.6-2.1 1.1 0 1.55.8 1.55 2.1V18h2.75v-4.7z"
    />
  </svg>
);

export const AppleIcon: React.FC = () => (
  <svg
    className="w-5 h-5"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
  </svg>
);
